export enum RefundStatusStep {
    IN_PROGRESS= 'IN_PROGRESS',
    REFUNDED= 'REFUNDED',
    NOT_REFUNDED= 'NOT_REFUNDED'
}
